import React, { Fragment, useMemo } from 'react'
import { NextPage } from 'next'

import { Container } from '@ucheba/ui/components/Container/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { useSelector } from 'react-redux'
import { institutionsRankingsSelectors } from '@ucheba/store/institutions/rankings'
import { EProgramTypes } from '@ucheba/utils/types/program'
import { analyticEvent } from '@ucheba/utils/helpers/analytics/events'
import {
  EAnalyticEvents,
  EAnalyticEventTargets,
  EAnalyticSections,
} from '@ucheba/utils/helpers/analytics/events/types'
import { Banner } from '../../../../../components/Banner/desktop'
import { IVuzRankingsPageProps } from '../types'
import { InstitutionsRanking } from '../../../../../components/InstitutionsRanking/desktop'
import {
  EApplicationFormProductTypes,
  EApplicationFunnels,
} from '../../../../../components/AppliactionForm/types'
import { ETypeRequest } from '../../../ege/index/types'
import LidMagnetForm from '../../../../../components/LidMagnetForm/desktop'

/** Страница с рейтином вузов */
const VuzRankingsPage: NextPage<IVuzRankingsPageProps> = (props) => {
  const { content } = props
  const { title } = content

  const rankings = useSelector(institutionsRankingsSelectors.selectAll)

  const extraParams = useMemo(() => {
    return {
      programTypes: EProgramTypes.higher,
    }
  }, [])

  return (
    <Container>
      <Spacing spacing='xlarge' />

      <Grid as='main'>
        <GridCol as='article' uxs={17} lg={18}>
          <Heading h1={title} spacing='small' />

          {rankings.map((ranking, index) => (
            <Fragment key={index}>
              <InstitutionsRanking {...ranking} />

              {(index === 0 || index === 2) && (
                <>
                  <Spacing spacing='xlarge' />

                  <Banner id={2} extraParams={extraParams} />
                </>
              )}

              {index === 1 && (
                <>
                  <Spacing spacing='xlarge' />

                  <LidMagnetForm
                    title='Хочешь поступить в&nbsp;топовый вуз на бюджет?'
                    text='Поможем в онлайн-школе Учёба.ру подготовиться к ЕГЭ на высокие баллы с гарантией поступления'
                    size='small'
                    funnel={EApplicationFunnels.vuz_rankings}
                    productType={EApplicationFormProductTypes.ege}
                    requestTarget={ETypeRequest.ege_lead_request}
                    onSubmitForm={() => {
                      analyticEvent({
                        targets: [EAnalyticEventTargets.ym, EAnalyticEventTargets.ur],
                        eventName: EAnalyticEvents.leadFormRequestSpeciality,
                        section: EAnalyticSections.leadMagnetForm,
                      })
                    }}
                    list={[
                      'Расскажем о системе эффективной подготовки',
                      'Познакомим с онлайн-школой и платформой',
                      'Ответим на вопросы и запишем на занятия',
                    ]}
                  />
                </>
              )}

              {index !== rankings.length - 1 && <Spacing spacing='uxlarge' />}
            </Fragment>
          ))}
        </GridCol>

        <GridCol uxs={7} lg={6} as='aside'>
          <div style={{ position: 'sticky', top: 0, paddingBottom: '30px' }}>
            <Banner id={3} extraParams={extraParams} />
          </div>
        </GridCol>
      </Grid>

      <Spacing spacing='uxlarge' />

      <Banner id={6} extraParams={extraParams} />

      <Banner id={14} extraParams={extraParams} />
    </Container>
  )
}

export default VuzRankingsPage
